import BasicCopyButton from './BasicCopyButton';

export default BasicCopyButton;